<template>
  <div class="dashboard">
    <div class="row row-equal">
      <div class="flex xs12">
        <div class="row">
          <div class="flex xs12 md6">
            <router-link to="/rezervasyon/listesi?durum=approved">
              <va-card :color="'secondary'">
                <p class="display-2 mb-1" style="color: white">{{ item.approved_rent_count }}</p>
                <p class="no-wrap">{{$t('dashboard.info.rents')}}</p>
              </va-card>
            </router-link>
          </div>
          <div class="flex xs12 sm3">
            <router-link to="/arac/listesi">
              <va-card class="mb-4" color="dark">
                <p class="display-2 mb-0" style="color: white">{{ item.vehicle_count }}</p>
                <p>{{$t('dashboard.info.vehicles')}}</p>
              </va-card>
            </router-link>
          </div>
          <div class="flex xs12 sm3">
            <router-link to="/uye/listesi">
              <va-card class="mb-4" color="gray">
                <p class="display-2 mb-0" style="color: white">{{ item.user_count }}</p>
                <p>{{$t('dashboard.info.users')}}</p>
              </va-card>
            </router-link>
          </div>
        </div>
      </div>

      <div class="flex xs6">
        <va-card
          stripe="primary"
          class="text--center"
        >
          <template slot="header">
            <va-icon name="fa fa-car mx-auto" color="primary"/>
          </template>
          <h5 class="mt-0 mb-2">{{ $t('dashboard.info.todaysRentPickups') }}</h5>
          <p class="display-1 mb-5" :style="{color: this.$themes.primary}">{{ item.pickup_today_rent_count }}</p>
          <div class="text--center">
            <va-button color="primary" :to="'/rezervasyon/listesi?durum=!canceled&alim='+today">
              {{$t('dashboard.info.viewList')}}
            </va-button>
          </div>
        </va-card>
      </div>

      <div class="flex xs6">
        <va-card
          stripe="info"
          class="text--center"
        >
          <template slot="header">
            <va-icon name="entypo entypo-key" color="info" class="mx-auto"/>
          </template>
          <h5 class="mt-0 mb-2">{{ $t('dashboard.info.todaysRentDropoffs') }}</h5>
          <p class="display-1 mb-5" :style="{color: this.$themes.info}">{{ item.dropoff_today_rent_count }}</p>
          <div class="text--center">
            <va-button color="info" :to="'/rezervasyon/listesi?durum=!canceled&teslim='+today">
              {{$t('dashboard.info.viewList')}}
            </va-button>
          </div>
        </va-card>
      </div>

      <div class="flex xs12">
        <va-card>
          <div class="row row-separated">
            <div class="flex xs6">
              <p class="display-2 mb-1 text--center" :style="{color: this.$themes.primary}">{{$t('dashboard.info.upcomingRentPickups')}}</p>
              <p class="text--center mb-1">
                <va-button color="primary" :to="'/rezervasyon/listesi?durum=!canceled&alim=>'+today">
                  {{$t('dashboard.info.viewList')}}
                </va-button>
              </p>
            </div>
            <div class="flex xs6">
              <p class="display-2 mb-1 text--center" :style="{color: this.$themes.info}">{{$t('dashboard.info.upcomingRentDropoffs')}}</p>
              <p class="text--center no-wrap mb-1">
                <va-button color="info" :to="'/rezervasyon/listesi?durum=!canceled&teslim=>'+today">
                  {{$t('dashboard.info.viewList')}}
                </va-button>
              </p>
            </div>
          </div>
        </va-card>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment"
import statsServices from '../../services/api/stats'
export default {
  data () {
    return {
      item: {},
      today: null
    }
  },
  methods: {
    async getStats() {
      const result = await statsServices.get();
      if(result.error){
        return ;
      }
      this.item = result.data.data;
    },
  },
  created () {
    this.today = moment().format('DD.MM.YYYY');
    this.getStats();
  }
}
</script>

<style lang="scss">
  .row-equal .flex {
    .va-card {
      height: 100%;
    }
  }
  .dashboard {
    .va-card {
      margin-bottom: 0 !important;
    }
  }
  .row-separated {
    .flex + .flex {
      border-left: 1px solid #e3eaeb;
    }

    @include media-breakpoint-down(xs) {
      p:not(.display-2){
        font-size: 0.875rem;
      }
    }
  }

  .dashboard {
    .va-card__header--over {
      @include media-breakpoint-up(md) {
        padding-top: 0 !important;
      }
    }

    .va-card__image {
      @include media-breakpoint-up(md) {
        padding-bottom: 0 !important;
      }
    }
  }
</style>